module.exports = "https://static.im-cdn.com/mjc/storefront/Anchor/static/media/Phone.24fe3f1c.svg";